
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTemperatureAir as ObiTemperatureAirElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-temperature-air.js';
 
 
 

 
 export const ObiTemperatureAir = createComponent({
   react: React,
   tagName: 'obi-temperature-air',
   elementClass: ObiTemperatureAirElement,
   events: {
     
   }
  });
 
 